import { Button, message, Modal, Select } from "antd"
import React, { useEffect, useMemo, useState } from "react"
import { useActions } from "../hooks/useActions"
import { useTypedSelector } from "../hooks/useTypedSelector"
import projectApi from "../api-wrapper/project/project"

interface AddCampaignToProjectProps {
  campaignIds: number[]
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const AddCampaignToProject = React.memo(function AddCampaignToProject({
  campaignIds,
  isOpen,
  setIsOpen,
}: AddCampaignToProjectProps) {
  const { projects, loaded, error } = useTypedSelector((state) => state.projectsList)
  const { fetchProjectsList } = useActions()
  const [selectedProject, setSelectedProject] = useState<string | null>(null)

  const selectItems = useMemo(
    () =>
      projects.map((project) => ({
        label: project.title,
        value: project._id,
      })),
    [projects]
  )

  function addToProject() {
    if (!campaignIds.length) {
      message.error("Please select campaigns")
      return
    }

    if (!selectedProject) {
      message.error("Please select a project")
      return
    }

    projectApi
      .addCampaignToProject(campaignIds, selectedProject)
      .then(() => {
        message.success("Campaigns added to project")
        setIsOpen(false)
        setSelectedProject(null)
      })
      .catch((error: any) => {
        message.error("Error adding campaigns to project")
        console.log(error)
      })
  }

  useEffect(() => {
    fetchProjectsList()
  }, [])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  return (
    <Modal
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={<Button onClick={addToProject}>Add to project</Button>}
    >
      <Select
        options={selectItems}
        onChange={(value: string) => setSelectedProject(value)}
        value={selectedProject}
        showSearch={true}
        style={{ width: "50%" }}
        placeholder="Select project"
        loading={loaded}
        disabled={loaded}
      />
    </Modal>
  )
})

export default AddCampaignToProject
